import { render, staticRenderFns } from "./MatchManage.vue?vue&type=template&id=592cff24&scoped=true&"
import script from "./MatchManage.vue?vue&type=script&lang=js&"
export * from "./MatchManage.vue?vue&type=script&lang=js&"
import style0 from "./MatchManage.vue?vue&type=style&index=0&id=592cff24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592cff24",
  null
  
)

export default component.exports